import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  templateUrl: './views/disableMode.html'
})
export class DisableModeExample implements OnInit {

  itemList = [];
  selectedItems = [];
  settings: any = {};

  constructor() {

  }
  ngOnInit() {


    this.itemList = [
      { "id": 1, "itemName": "Brazil" },
      { "id": 2, "itemName": "Argentina" },
      { "id": 3, "itemName": "Chile" },
      { "id": 4, "itemName": "Canada" },
      { "id": 5, "itemName": "Colombia" },
      { "id": 6, "itemName": "Brazil" }
    ];

    this.selectedItems = [
      { "id": 1, "itemName": "Brazil" },
      { "id": 2, "itemName": "Argentina" },
      { "id": 3, "itemName": "Chile" },
      { "id": 4, "itemName": "Canada" }];
    this.settings = {
      text: "Select Countries",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: false,
      classes: "myclass custom-class",
      disabled: true,
      tagToBody: false
    };
  }
  onItemSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  OnItemDeSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  onSelectAll(items: any) {
    console.log(items);
  }
  onDeSelectAll(items: any) {
    console.log(items);
  }
  showModel() {
    console.log(this.selectedItems);
  }
  changeData() {
    this.selectedItems = [];
  }
  disable() {
    this.settings = {
      text: "Select Countries",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: false,
      classes: "myclass custom-class",
      disabled: true
    };
  }
  enable() {
    this.settings = {
      text: "Select Countries",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: false,
      classes: "myclass custom-class",
      disabled: false
    };
  }
  toggleDisable() {
    console.log(this.settings);
    this.settings = {
      text: "Select Countries",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: false,
      classes: "myclass custom-class",
      limitSelection: 2,
      disabled: false
    };
  }
  cssgist: boolean = false;
  title: string = "Disable mode";
  tsgist: string = "CuppaLabs/96f799302bdfa08e11b4420c86c1d720";
  htmlgist: string = "CuppaLabs/eb78d42ab7971fda6493586e329bfdb8";
  tstitle: string = "disableMode.ts"
  htmltitle: string = "disableMode.html";
}
